/**
 * Tenant utilities for extracting and formatting tenant information
 */

/**
 * Extract tenant subdomain from current hostname
 */
export const getTenantSubdomain = (): string | null => {
  const hostname = window.location.hostname;
  
  // Handle .localhost development
  if (hostname.endsWith('.localhost')) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const subdomain = parts[0];
      // Skip common subdomains
      if (subdomain !== 'enterprise' && subdomain !== 'www' && subdomain !== 'admin') {
        return subdomain; // e.g., "zeroeffort" from "zeroeffort.localhost"
      }
    }
  }
  
  // Handle production domains
  if (hostname.includes('.')) {
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      const subdomain = parts[0];
      // Skip common subdomains
      if (subdomain !== 'enterprise' && subdomain !== 'www' && subdomain !== 'admin') {
        return subdomain;
      }
    }
  }
  
  // Check URL parameter as fallback for development
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('tenant');
};

/**
 * Format tenant name for display (capitalize first letter of each word)
 */
export const formatTenantName = (tenantSlug: string | null): string => {
  if (!tenantSlug) return 'Laboratory';
  
  // Convert slug to display name
  // e.g., "zeroeffort" -> "Zero Effort"
  // e.g., "pets-concern-ltd" -> "Pets Concern Ltd"
  return tenantSlug
    .split(/[-_]/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Get formatted tenant display name
 */
export const getTenantDisplayName = (): string => {
  const tenantSlug = getTenantSubdomain();
  return formatTenantName(tenantSlug);
};